module.exports = __webpack_public_path__ + "static/media/logo.37f7425b.svg";